export function BrandMark() {
  // Três pontos de restauração empilhados: o último é o mais longo.
  return (
    <svg className="brand-mark" viewBox="0 0 26 26" aria-hidden="true">
      <rect width="26" height="26" rx="6" fill="#3b43c4" />
      <rect x="6" y="7" width="9" height="3" rx="1.5" fill="#ffffff" fillOpacity="0.55" />
      <rect x="6" y="11.5" width="12" height="3" rx="1.5" fill="#ffffff" fillOpacity="0.8" />
      <rect x="6" y="16" width="15" height="3" rx="1.5" fill="#ffffff" />
    </svg>
  );
}

export function Brand() {
  return (
    <div className="brand">
      <BrandMark />
      <span className="brand-name">E-<span>BACKUP</span></span>
    </div>
  );
}
